// 本番保存PDF651,014件の最大4.43MiBに対し、約5.6倍の余裕を確保した上限
// 集計したPDFに25MiB超過はなく、通常利用を維持しながら一時領域の消費を制限する
export const MAX_PDF_FILE_SIZE = 25 * 1024 * 1024;
export const MAX_PDF_TOTAL_SIZE = 250 * 1024 * 1024;
